module.exports = __webpack_public_path__ + "img/spinner.b05e0b7d.svg";